import React from 'react';
import { Link } from 'react-router-dom';
import { Gift, ArrowRight } from 'lucide-react';

/**
 * Last-chance bundle upsell shown right before the payment section on
 * standalone product pages. Encourages buyers to upgrade to the Snatched Duo
 * Bundle ($89.99 = both fajas + free boyshorts).
 */
export const BundleUpsell = ({ hookText, ctaText = 'See the bundle' }) => {
  return (
    <Link
      to="/"
      data-testid="bundle-upsell-callout"
      className="block group relative overflow-hidden rounded-2xl border-2 border-[#d4af37] bg-gradient-to-br from-[#7d1f3d] via-[#6d1a36] to-[#5d1729] text-white p-5 shadow-xl hover:shadow-2xl transition-shadow"
    >
      <div className="flex items-center gap-4">
        <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#d4af37] flex items-center justify-center">
          <Gift className="w-6 h-6 text-[#5d1729]" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-[#d4af37] text-[11px] font-bold uppercase tracking-wider mb-0.5">
            Snatched Duo Bundle — $89.99
          </p>
          <p className="text-white font-semibold text-sm md:text-base leading-snug">
            {hookText}
          </p>
        </div>
        <div className="hidden sm:flex flex-col items-end text-right flex-shrink-0">
          <span className="text-[#d4af37] text-xs font-bold uppercase tracking-wider">{ctaText}</span>
          <ArrowRight className="w-5 h-5 text-[#d4af37] group-hover:translate-x-1 transition-transform mt-1" />
        </div>
      </div>
    </Link>
  );
};
